import 'jq/req/mobilefix';
import 'jq/req/eutils';
import 'jq/req/ga';
import 'jq/req/x/cookie';
import 'jq/req/onformatchange';
import 'jq/req/mobilemenu';
import 'jq/req/autovalidate';
import 'jq/req/anchortags';
import 'jq/req/sharebtns';
import './_js/owl.carousel.min.js';
// import './_js/TweenMax.min.js';
// import 'jq/req/selectybox';
// import 'jq/req/treecollapse';
import 'jq/req/whenonscreen';
// import 'jq/req/fieldsetcloner';
import 'jq/req/q-paginazor';
// import 'jq/req/listscroller';
// import 'jq/req/delayedhighlight';
// import 'jq/req/tabswitcher';
// import 'jq/req/q-videolinks';
// import 'jq/req/x/ui-core-1.12';
// import 'jq/req/x/ui-menu-1.12';
// import 'jq/req/x/ui-autocomplete-1.12';
// import 'jq/req/x/ui-datepicker-1.12';
import cfg from './config.json';
window.jQuery(function($) {
	'use strict';

	const $html = $('html');

	const $win = $(window);
	// const $body = $('body');
	const $doc = $(document);

	const formatMonitor = $.formatChange(window.FormatChange.makeGroups(cfg.mediaFormats));
	const media = formatMonitor.media;

	let txt;
	const i18n = { en: {} };

	i18n.is = $.beget(i18n.en);
	txt = i18n[$('html').attr('lang')] || i18n.en;

	// =========================================================================================================================
	//   Default Configs
	// =========================================================================================================================

	// =========================================================================================================================
	//   Actions
	// =========================================================================================================================

	const loggedIn = window.EPLICA_loggedin;
	const noop = $.noop;

	const tagFileAndExternalLinks = function() {
		i18n.en.newWindow = 'Opens in new window';
		i18n.is.newWindow = 'Opnast í nýjum vafraglugga';
		i18n.en.fileText = 'file';
		i18n.is.fileText = 'skjal';

		$('a:not(.videolink)').anchorTags({
			usePatterns: ['doc', 'pdf', 'xls'],
			// localDomains: ['\\.*.eplica.is','\\.*.domain.is'],
			onTag: function(link, is) {
				const text = is.pattern
					? is.pattern[0].toUpperCase() + ' ' + txt.fileText
					: is.external
					? txt.newWindow
					: '';
				text &&
					link
						.attr('target', '_blank')
						.attr('title', $.trim(link.attr('title') || link.text()) + ' (' + text + ')');

				if (link.find('img').length) {
					link.addClass('has-image');
				}

				const gaCat = is.external
					? 'external'
					: is.tel
					? 'telephone'
					: is.mailto
					? 'email'
					: is.pattern
					? 'download'
					: '';
				if (window.ga && gaCat) {
					link.on('click', function(/*e*/) {
						window.gaHXM.eventPing(
							gaCat,
							is.pattern ? 'click-' + is.pattern[0] : 'click',
							link.attr('href').replace(/^(tel|mailto):/i, ''),
							1,
							is.external ? true : false
						);
					});
				}
			},
		});
	};

	const _collapseCollapseBlocks = function(article) {
		article.find('.collapse').each(function() {
			const head = $(this).addClass('collapse-active collapse-closed');
			head
				.nextUntil('h2, h3, hr, div, .buttons, .share-widgets')
				.wrapAll('<div class="collapseouter" style="display: none" />')
				.wrapAll('<div class="collapsebox" />');
			head.wrapInner('<a href="#" />').on('click', function(e) {
				head
					.toggleClass('collapse-closed')
					.next()
					.slideToggle('fast');
				e.preventDefault();
			});
		});
	};

	const injectShareBtns = function() {
		$('<ul class="share__list" />')
			.sharebtns({
				custom: true,
				wrap: 'li',
				// countNone: true,
				fbshare: 1,
				twitter: 2,
				email: 3,
				// gplus:     2,
				// pinterest: 3,
			})
			.end()
			.appendTo($('.share__inner__wrapper'));
		$('.share__list')
			.find('.facebook')
			.remove();
		$('.share__list').prepend('<li class="share__trigger"><a href="#">Deila</a></li>');
		$('.share__list').append('<li class="messenger"><a href="/url">Messenger</a></li>'); // temp messenger item
	};

	const prepArticleContent = function() {
		$('.article').each(function() {
			const article = $(this);
			_collapseCollapseBlocks(article);
		});
	};

	const initForms = function() {
		$('form').autoValidate({
			errorMsgType: 'inlineonly',
			validateEachField: 'change',
		});
	};

	const handleTelephoneLinks = function() {
		// depends on formatChange()
		i18n.is.callPrompt = 'Hringja í ';
		i18n.en.callPrompt = 'Call ';
		$doc.on('click', 'a[href^="tel:"]', function(e) {
			if (media.isLarge) {
				const m = $(this)
						.text()
						.match(/\+?\d[\s\-\d]+\d/),
					num = (m && m[0]) || this.href.substr(4);
				if (!confirm(txt.callPrompt + num + ' ?')) {
					e.preventDefault();
				}
			}
		});
	};

	const initCarousel = () => {
		const $imageCarousel = $('.carousel .carousel__boxbody');

		if ($imageCarousel.length) {
			if ($imageCarousel.find('.carousel__item').length > 1) {
				$imageCarousel.addClass('owl-carousel').owlCarousel({
					transitionStyle: 'fade',
					autoplay: false,
					dots: true,
					items: 1,
					loop: true,
					center: true,
					nav: false,
					smartSpeed: 400,
					info: true,
					singleItem: true,
					navText: ['<span>&#x2039;Next</span>', '<span>&#x203a;Prev</span>'],
					responsiveClass: true,
					responsive: {
						0: {
							stagePadding: 0,
						},
						1280: {
							stagePadding: 200,
						},
						1440: {
							stagePadding: 0,
							margin: 100,
						},
					},
					onInitialized: function(e) {
						const $cont = $(e.target);
						$cont.find('[role]').removeAttr('role');
						$cont.find('.owl-item').attr('aria-hidden', 'true');
						$cont.find('.owl-item.active').removeAttr('aria-hidden');
						$cont.find('.cloned > [id]').removeAttr('id');
					},
					onChanged: function(e) {
						const $cont = $(e.target);
						setTimeout(function() {
							$cont.find('.owl-item').attr('aria-hidden', 'true');
							$cont.find('.active').removeAttr('aria-hidden');
						}, 50);
					},
				});
				let i = 1;
				$('.carousel .owl-dot').each(function() {
					$(this)
						.text(i)
						.prepend('0');
					i++;
				});
			}
		}
	};

	const share = () => {
		const share = document.querySelector('.article .share');
		if (share || !share === null) {
			if (media.isHeaderSmall) {
				share.classList.add('share--slide');
				share.classList.add('share--hidden');
			}

			if (media.isHeaderLarge) {
				$win.on(
					'scroll',
					$.throttleFn(function() {
						const top = window.pageYOffset;
						if (top > 180) {
							share.classList.add('share--hidden');
							share.classList.add('share--slide');
						} else {
							share.classList.remove('share--hidden');
							share.classList.remove('share--slide');
							share.classList.remove('share--fixed');
						}
					})
				);
			}

			const shareTriggerBtn = share.querySelector('.share__trigger a');
			shareTriggerBtn.addEventListener('click', function(e) {
				e.preventDefault();
				if (share.classList.contains('share--hidden')) {
					share.classList.remove('share--hidden');
				} else {
					share.classList.add('share--hidden');
				}
			});

			if (window.IntersectionObserver) {
				const shareWrapper = document.querySelector('.share__wrapper');
				const observer = new IntersectionObserver(
					(entries) => {
						entries.forEach((entry) => {
							if (entry.intersectionRatio === 0) {
								shareWrapper.classList.add('share--fixed');
							} else {
								shareWrapper.classList.remove('share--fixed');
							}
						});
					},
					{
						rootMargin: '-450px 0px 0px 0px',
						threshold: 0,
					}
				);
				observer.observe(share);
			}
		}

		const messengerBtn = document.querySelector('.messenger a');
		const link = window.location.href;
		// needs a valid appId
		const appId = '261633064813452';
		messengerBtn.addEventListener('click', function(e) {
			e.preventDefault();
			window.open(
				'fb-messenger://share?link=' +
					encodeURIComponent(link) +
					'&app_id=' +
					encodeURIComponent(appId)
			);
		});
	};

	const initObserverAnimation = () => {
		const $contentblocks = $('.observer');
		if ($contentblocks.length) {
			const aTitleInnblastur = $('.post-type-archive-innblastur .articlelist h2');
			const aTitleReynslusaga = $('.post-type-archive-reynslusogur .articlelist h2');
			aTitleInnblastur.text('').append($('<span>Fáðu </span> <span>innblástur</span>'));
			aTitleReynslusaga
				.text('')
				.append($('<span>Hvernig myndi líf</span> <span>þitt breytast</span>'));
			const ranges =
				media.format === 'wide'
					? { top: '-5%s', bottom: '-5%s' }
					: media.isHeaderLarge
					? { top: '-15%s', bottom: '-5%s' }
					: { top: '-5%s', bottom: '-2%s' };
			$contentblocks
				.whenOnScreen({
					live: true,
					ranges: { visible: ranges },
				})
				.on('whenonscreen', function() {
					$(this)
						.addClass('onscreen')
						.off('whenonscreen');
				});
		}
	};

	const prepFooter = () => {
		const footer = document.querySelector('.pgfoot');
		const articleShare = document.querySelector('.article .share');
		const html = document.querySelector('html');
		if (media.isHeaderSmall) {
			if (
				(window.IntersectionObserver && footer && articleShare) ||
				!footer === null ||
				!articleShare === 0
			) {
				const observer = new IntersectionObserver(
					(entries) => {
						entries.forEach((entry) => {
							if (entry.intersectionRatio === 0) {
								html.classList.remove('hide-article-share');
								articleShare.classList.add('share--hidden');
							} else {
								html.classList.add('hide-article-share');
							}
						});
					},
					{
						rootMargin: '-450px 0px 0px 0px',
						threshold: 0,
					}
				);
				observer.observe(footer);
			}
		}
	};

	const prepMobileMenu = function() {
		const footerCol = document.querySelector('.footer__col--second');
		const subscr = document.querySelector('.subscr');
		if (footerCol || !footerCol === null) {
			$win
				.on('mobilemenuopen', function() {
					$('.mnav').append(subscr);
				})
				.on('mobilemenuclosed', function() {
					$('.footer__col--second').append(subscr);
				});
		}
	};

	const initCookieDisclaimer = () => {
		i18n.is.moreText = 'Sjá nánar';
		i18n.en.moreText = 'More';
		i18n.is.closeText = 'Samþykkja';
		i18n.en.closeText = 'Close';
		i18n.en.cookieText =
			'This website uses cookies to measure traffic."><a href="/cookies" class="disclaimer__more">Sjá nánar (á ensku)</a>.';
		i18n.is.cookieText = 'Þessi vefur notar vafrakökur til notkunarmælinga.';
		if (!$.cookie('jsdisclaimer')) {
			const disclaimer = $(
				'<div class="disclaimer">' +
					'<div class="text">' +
					txt.cookieText +
					'</div>' +
					'<a href="/vafrakokur" class="disclaimer__more">' +
					i18n.is.moreText +
					'</a>' +
					'<button type="button" class="close">' +
					txt.closeText +
					'</button>' +
					'</div>'
			);
			$('body').append(disclaimer);
			setTimeout(function() {
				$('.disclaimer').addClass('disclaimer--visible');
			}, 2000);
			disclaimer.find('.read').on('click.close', function(e) {
				disclaimer.find('.close').trigger('click.close');
			});
			disclaimer.find('.close').on('click.close', function(e) {
				e.preventDefault();
				disclaimer.removeClass('disclaimer--visible');
				$.cookie('jsdisclaimer', '1', { expires: 365, path: '/' });
			});
		}
	};

	const expand = () => {
		const timelineContent = document.querySelectorAll('.expand');
		if (timelineContent && timelineContent !== null) {
			timelineContent.forEach((item) => {
				const expandBtn = item.querySelector('.expand__more');
				const mainContent = item.querySelector('.expand__main');
				const closeBtn = item.querySelector('.expand__mainClose');
				if (mainContent && mainContent !== null) {
					if (expandBtn && expandBtn !== null) {
						const expandBtnText = expandBtn.innerText;
						expandBtn.addEventListener('click', function(t) {
							if (!t.target.classList.contains('expand__moreActive')) {
								t.target.classList.add('expand__moreActive');
								t.target.innerText = 'Lesa minna';
								mainContent.classList.add('expand__main--active');
							} else {
								t.target.classList.remove('expand__moreActive');
								mainContent.classList.remove('expand__main--active');
								t.target.innerText = expandBtnText;
							}
						});
					}

					if (closeBtn || closeBtn !== null) {
						closeBtn.addEventListener('click', function() {
							mainContent.classList.remove('expand__main--active');
							expandBtn.classList.remove('expand__moreActive');
						});
					}
				}
			});
		}
	};

	const filterList = (pageClass, item) => {
		const html = document.querySelector('html');
		if (html.classList.contains(pageClass)) {
			const menu = document.querySelectorAll('.pagenav .menu-item a');
			const items = document.querySelectorAll(item);
			document.querySelector('.pagenav .menu-item').classList.add('current-menu-item');
			menu.forEach((menuItem) => {
				menuItem.addEventListener('click', (e) => {
					e.preventDefault();
					menuItem.parentElement.parentElement
						.querySelectorAll('.menu-item')
						.forEach((m) => m.classList.remove('current-menu-item'));
					e.target.parentElement.classList.add('current-menu-item');
					items.forEach((itm) => {
						itm.classList.add('hidden');
						const attr = itm.getAttribute('data-attribute');
						if (e.target.text.toLowerCase() === attr) {
							itm.classList.remove('hidden');
							itm.classList.add('onscreen');
						} else if (e.target.text.toLowerCase() === 'allt') {
							itm.classList.remove('hidden');
						}
					});
				});
			});
		}
	};

	filterList('page-allt', '.sos');

	const youTube = () => {
		const videos = document.querySelectorAll('.youtube-video');
		if (videos && videos !== null) {
			videos.forEach((video) => {
				const youtubePoster = video.querySelector('.youtube-video__poster');
				const iframe = video.getElementsByTagName('iframe')[0].contentWindow;
				function controlVideo(vidcontrol) {
					//video.classList.remove('youtube-video--active');
					iframe.postMessage(
						'{"event":"command","func":"' + vidcontrol + '","args":""}',
						'*'
					);
				}
				// btn.addEventListener('click', controlVideo('playVideo'));
				youtubePoster.addEventListener('click', () => {
					video.classList.add('youtube-video--active');
					controlVideo('playVideo');
				});
			});
		}
	};

	// =========================================================================================================================
	//   Run Init Actions
	// =========================================================================================================================

	$('ol').attr('data-oltype', function() {
		return this.type || '';
	}); // enable fancy styling on <ol> markers....

	tagFileAndExternalLinks(); // Þarf að keyrast soldið seint vegna ga tracking
	$('table:not(table table)').wrap('<div class="tablewrap" />');

	prepArticleContent();
	initForms();
	initCarousel();
	initObserverAnimation();
	injectShareBtns();
	share();
	prepMobileMenu();
	initCookieDisclaimer();
	prepFooter();
	expand();
	youTube();

	$.initMobileMenu({
		mediaGroup: 'HeaderSmall',
		stickyHeader: true,
		resetScroll: false,
	});

	$.initStickyHeader({
		mediaGroup: null,
		headerHeight: function() {
			return parseInt(
				window.getComputedStyle(document.documentElement).getPropertyValue('padding-top')
			);
		},
	});

	handleTelephoneLinks(); // <- depends on formatChange

	$('html').removeClass('beforejsinit'); //remove flicker trick

	$.fixSkiplinks && $.fixSkiplinks();
});
